import { useState } from "react";
import { FaQrcode } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import FormsQrScannerModal from "./FormsQrScannerModal";

type FormsQrScanButtonProps = {
  className?: string;
};

// Trigger button for the MYKOKU Forms QR scanner. Matches the existing
// bordered full-width button styling used elsewhere (e.g. "Edit Profile" in
// src/pages/Profile/Profile.tsx). The camera only runs while the overlay is
// open (see FormsQrScannerModal).
const FormsQrScanButton = ({ className }: FormsQrScanButtonProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className={
          className ??
          "px-4 py-2 w-full border-2 rounded-xl text-center items-center flex justify-center gap-2"
        }
        onClick={() => setIsOpen(true)}
      >
        <FaQrcode className="text-xl text-gray-600" />
        <span>{t("qrScanner.scanFormQr")}</span>
      </button>
      <FormsQrScannerModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default FormsQrScanButton;
